import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import Item from "../subComponent/Item";
import ProductSidebar from "./ProductSidebar";
import { BiUpArrow } from "react-icons/bi";
import SearchNotSeen from "../assets/notsearchresult.png";
import { Rating, Stack } from "@mui/material";
const SearchPage = () => {
  const {
    categories,
    CategoriesApiCall,
    singleCategoryDetails,
    setSingleCategoryDetails,
    setIsScrolled,
    singleCategory,
    sidebarOpened,
    cartItem,
    sidebarCartDetail,
    setSidebarCartDetail,
    searchPageDetails,
  } = useStateContext();
  const { id } = useParams();
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Clear single category details
    setSingleCategoryDetails([]);

    // Make API calls
    CategoriesApiCall();
    searchPageDetails(id);

    // Set loader to false
    setLoader(false);
  }, [id]);

  useEffect(() => {
    // Set sidebar cart detail based on cartItem length
    setSidebarCartDetail(false);
    if (cartItem) {
      if (cartItem.length > 0) {
        setSidebarCartDetail(true);
      } else {
        setSidebarCartDetail(false);
      }
    }

    console.log(sidebarCartDetail);
  }, [cartItem]);

  // Set scroll event listener
  window.onscroll = () => {
    setIsScrolled(window.pageYOffset === 0 ? false : true);
    return () => (window.onscroll = null);
  };

  return (
    <Component>
      <div
        className="result-bar"
        style={{ width: `${sidebarCartDetail ? "88.4%" : "100%"}` }}
      >
        {singleCategoryDetails.length} results for <span>"{id}"</span>
      </div>
      <div className="result">
        <FilterSideBar
          style={{ width: `${sidebarCartDetail ? "15%" : "20%"}` }}
        >
          <Filter>
            <CategoriesFilter>
              <h3>Categories</h3>

              {categories.map((category, i) => (
                <Link to={`/category/${category.categories_id}`} key={i}>
                  <p>{category.title}</p>
                </Link>
              ))}
            </CategoriesFilter>
            <PriceFilter>
              <h3>Price</h3>
              <p>Up to $25</p>
              <p>$25 to $50</p>
              <p>$50 to $100</p>
              <p>$100 to $200</p>
              <p>$200 & above</p>
            </PriceFilter>
            <RatingsFilter>
              <h3>Ratings</h3>
              <div className="rating">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    value={4.4}
                    precision={0.1}
                    readOnly
                  />
                </Stack>
              </div>
              <div className="rating">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    value={4}
                    precision={0.1}
                    readOnly
                  />
                </Stack>
              </div>
              <div className="rating">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    value={3.4}
                    precision={0.1}
                    readOnly
                  />
                </Stack>
              </div>
            </RatingsFilter>
          </Filter>
        </FilterSideBar>
        <Items style={{ width: `${sidebarCartDetail ? "75%" : "80%"}` }}>
          {singleCategoryDetails.length < 1 ? (
            <SearchPageNotFound>
              <div className="text">Search Result Not Found</div>
              <img src={SearchNotSeen} alt="" srcset="" />
            </SearchPageNotFound>
          ) : (
            <ItemWrapper>
              {singleCategoryDetails.map((details, i) => (
                <Item
                  key={details.categories_id + i}
                  details={details}
                  categ_id={details.categories_id}
                />
              ))}
            </ItemWrapper>
          )}
        </Items>
      </div>

      <CartSideBar
        style={{
          width: `${sidebarCartDetail ? "10%" : 0}`,
          zIndex: `${sidebarOpened ? 0 : "1000"}`,
        }}
      >
        <BiUpArrow className="arrow" />

        <ProductSidebar />
      </CartSideBar>
    </Component>
  );
};

export default SearchPage;

const Component = styled.div`
  margin-top: 10vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;

  .result {
    display: flex;
    width: 100%;
  }
  .result-bar {
    height: 30px;

    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    padding-left: 20px;
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.08);
    -webkit-box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.08);
    span {
      color: #e56a6a;
      padding-left: 5px;
    }
  }
`;

const FilterSideBar = styled.div`
  border-right: 1px solid black;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const CartSideBar = styled.div`
  width: 17vw;

  max-height: 90vh;
  position: fixed;
  right: 0px;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  overflow-y: auto;
  display: flex;

  box-shadow: -6px 1px 5px 0px rgba(0, 0, 0, 0.13);
  -webkit-box-shadow: -6px 1px 5px 0px rgba(0, 0, 0, 0.13);
  -moz-box-shadow: -6px 1px 5px 0px rgba(0, 0, 0, 0.13);

  .arrow {
    font-size: 21px;
    position: fixed;
    top: 7.47vh;
    right: 82px;
    z-index: 4000;
    opacity: 0.4;
    overflow-y: visible;
  }
`;

const Items = styled.div`
  min-height: 100vh;
  display: flex;
  margin-top: 2vh;

  align-items: flex-start;
  justify-content: center;
`;

const ItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
`;

const CategoriesFilter = styled.div`
  width: 94%;
  h3 {
    text-align: left;
  }
  .rating {
    margin-left: 40px;
    width: 100%;
  }
  p {
    cursor: pointer;
    color: black;
    font-size: 12px;
    line-height: 12px;
    &:hover {
      text-decoration: underline;
    }
  }
  a {
    text-decoration: none;
  }
`;

const RatingsFilter = styled.div`
  width: 80%;
  .rating {
    transform: scale(0.8);
  }
  p {
    margin-left: 40px;
  }
`;

const PriceFilter = styled.div`
  width: 80%;
  p {
    margin-left: 4px;
    font-size: 13px;
    line-height: 10px;
  }
`;

const Filter = styled.div`
  position: absolute;
  width: 70%;
  top: 20px;
  h3 {
    margin: 0 2px;
  }
`;

const SearchPageNotFound = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .text {
    color: black;
  }
  img {
    height: 70vh;
    width: 70vw;
    object-fit: contain;
  }
`;
